import React, { useEffect, useRef } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

const SampleGroup = (props) => {
  const active = useRef(props.sample ? props.sample.active : false);
  const size = useRef(props.sample ? props.sample.size : "");
  const every = useRef(props.sample ? props.sample.every : "");

  useEffect(() => {
    try {
      // if (props.setSampleRows) {
      //   props.setSampleRows({
      //     size: size.current,
      //     every: every.current
      //   });
      // }

      active.current = props.sample.active;
      size.current = props.sample.size;
      every.current = props.sample.every;
    } catch(e) {
      return undefined;
    }
  }, [props.sample]);

  const changeHandler = (ref, val) => {
    ref.current = val;

    props.update({
      active: active.current,
      size: size.current,
      every: every.current
    });
  }
  
  return (
    <InputGroup size='sm' className="mb-3">
      <InputGroup.Prepend>
        {/* <InputGroup.Checkbox 
          checked={active.current}
          onChange={(evt) => changeHandler(active, evt.target.checked)} 
        /> */}
        <InputGroup.Text>Sample</InputGroup.Text>
      </InputGroup.Prepend>
      <FormControl 
        aria-label="Text input with checkbox" 
        value={size.current}
        onChange={(evt) => changeHandler(size, evt.target.value)} 
      />
      <InputGroup.Append>
        <InputGroup.Text>{props.name}s every</InputGroup.Text>
      </InputGroup.Append>
      <FormControl
        onChange={(evt) => changeHandler(every, evt.target.value)}
        value={every.current}
      />
      <InputGroup.Append>
        <InputGroup.Text>rows</InputGroup.Text>
      </InputGroup.Append>
    </InputGroup>
  );
}

export default SampleGroup;